
'use strict';

const _config = {
    formID: '',
    formObj: '',
    gridObj: '',
    gridBaseURL: '',
    firstExtract: '',
};


export function init(options) {
    if (!options) {
        options = {};
    }

    if (!options.gridObj || !options.gridBaseURL || !options.formObj){
        console.log('Missing Grid Options for Nomination Extract Grid');
        var alertBody = 'Unable to update grid. Please reload and try again';
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: alertBody});
        return false;
    };

    _config.gridObj = options.gridObj;
    _config.gridBaseURL = options.gridBaseURL;
    _config.formObj = options.formObj;
    _config.formID = options.formID;
    _config.firstExtract = options.firstExtract;

    $('.jq_button').button();
}

function getExtractSelection(){
    var $extractObj = new Object();
    $extractObj.season = _config.formObj.find('[name="season"]').val();
    $extractObj.mareIDs = _config.formObj.find('[name="mare_id"]').val();
    $extractObj.stallionIDs = _config.formObj.find('[name="stallion_id"]').val();
    $extractObj.statusIDs = _config.formObj.find('[name="status_id"]').val();
    $extractObj.termsID = _config.formObj.find('[name="stallion_terms"]').val();

    return $extractObj;
}

export function getExtractUrl(paramsOnly){
    var $extract = getExtractSelection();
    var params = '&mareID=' + $extract.mareIDs
        + '&stallionID=' + $extract.stallionIDs
        + '&season=' + $extract.season
        + '&termsID=' + $extract.termsID
        + '&statusID=' + $extract.statusIDs;
    var gridUrl = _config.gridBaseURL + params;

    if (paramsOnly){
        return params;
    }
    else {
        return gridUrl;
    }
}

export function reloadExtractGrid(){
    var gridURL = EQLAPP.APPSNOMSEXTRACT.getExtractUrl(false);
    _config.gridObj.jqGrid('setGridParam',{url: gridURL,page: 1}).trigger('reloadGrid');
}

export function extractResult(updateSelector,value,lastUpdate){

    $(updateSelector).customHide().html(value.trim()).customShow();

    if (lastUpdate == 1){
        EQLAPP.APPSNOMSEXTRACT.reloadExtractGrid();
        if (_config.formObj.data('first-extract')){
            $('.js-extractDiv').customShow();
            $gridObj.jqGrid('setGridWidth', 710);
        }
    }
}

export function extractNominations(){
    //Update Button Text
    setButtonText('#extractNominations', $.i18n('EXTRACT_NOMINATIONS'));

    //Create Loader - Displays a Loading Layout div over section 2.
    createLoader('#nomination_loader',
        'Extracting Nominations (Please Wait)...',
        $.i18n('EXTRACT_NOMINATIONS'));
    $('#nomination_loader').customShow();

    //Hide Hint 2
    $('.hint:visible').customHide();

    //Save Form
    setTimeout(() =>{
        saveForm(_config.formID);
    }, 3000);
}

export function enableButtons(numRecords){
    if (numRecords > 0){
        $('.btnInvoicePrint').removeClass('btn-disabled');
    } else {
        $('.btnInvoicePrint').addClass('btn-disabled');
    }
}

export function printNomInvoices()
{
    var invoiceDate = _config.formObj.find('[name="invoiceDate"]').val();
    var invoiceURL = jQuery.param.querystring('/pages/ajax_gen_win_appsnoms.cfm',{
        type: 'pop_print_nomination_invoices',
        report: '',
        invoiceDate: invoiceDate,
    });

    popWin({
        title: 'Print Stallion Nomination Invoices',
        popID: 'billingPopCommitInvoices',
        noAutoWidth: true,
        modal: true,
        width: 620,
        page: invoiceURL,
    });
}

